<plyca-ui-splitter [config]="{ panel: [{ panel: 'panel1' }, { panel: 'panel2' }], style: { height: '300px' }, panelSizes: [70, 30], minSizes: [70, 0] }">
  <ng-template let-element="layout" let-i="index">
    @if (i === 0) {
      TEST 1
    }
    @if (i === 1) {
      TEST2
    }
  </ng-template>
</plyca-ui-splitter>
